'use client';

import { __rest, __assign } from '../../_virtual/_tslib.js';
import React__default from 'react';

var VerticalMoreIcon = function (_a) {
    var _b = _a.color, color = _b === void 0 ? '#939393' : _b, _c = _a.width, width = _c === void 0 ? 24 : _c, rest = __rest(_a, ["color", "width"]);
    return (React__default.createElement("svg", __assign({}, rest, { width: width, height: width, viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }),
        React__default.createElement("circle", { cx: '12', cy: '4.5', r: '2.5', fill: color }),
        React__default.createElement("circle", { cx: '12', cy: '12', r: '2.5', fill: color }),
        React__default.createElement("circle", { cx: '12', cy: '19.5', r: '2.5', fill: color })));
};
var VerticalMoreIcon$1 = React__default.memo(VerticalMoreIcon);

export { VerticalMoreIcon$1 as default };
//# sourceMappingURL=index.js.map
